export default {
  styleOverrides: {
    responsiveBase: {
      border: '1px solid #C8C8C8',
      borderRadius: 8,
      borderCollapse: 'separate',
    },
  }
};
